import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { ToastMessageComponent } from "@shared/components/toast-message/toast-message.component";
import {
  ApiService,
  Region,
} from "@core/services/api/api.service";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { AuditPermissionService } from "@core/services/audit-permission.service";
import { CommonModule } from "@angular/common";
import { PrimeNGSharedModule } from "@shared/prime/prime-ng.module";
import { ModalComponent } from "@shared/components/modal/modal.component";

@Component({
  selector: "app-add-type-of-changes",
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PrimeNGSharedModule,
    ModalComponent,
    ToastMessageComponent,
  ],
  templateUrl: "./add-type-of-changes.component.html",
  styleUrl: "./add-type-of-changes.component.scss",
})
export class AddTypeOfChangesComponent {
  @Input() visible: boolean = false;
  @Input() editMode: boolean = false;
  @Input() data: any;

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() closeDialog = new EventEmitter<void>();
  permissionPop: boolean = false;
  @ViewChild(ToastMessageComponent) toast!: ToastMessageComponent;

  category: Region[] = [];
  typeOfChangesForm!: FormGroup;
  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private auditService: AuditPermissionService
  ) {
    this.initializeForm();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.editMode) {
      this.typeOfChangesForm.patchValue({
        category: this.data.category,
        typeOfChanges: this.data.name,
      });
    }
  }
  ngOnInit(): void {
    this.getChangeTypeCategories();
  }
  initializeForm(): void {
    this.typeOfChangesForm = this.fb.group({
      category: [null, Validators.required],
      typeOfChanges: [null, Validators.required],
    });
  }
  close() {
    this.closeDialog.emit();
    this.permissionPop = false;
    this.typeOfChangesForm.reset();
    this.typeOfChangesForm.markAsPristine();
    this.typeOfChangesForm.markAsUntouched();
    this.typeOfChangesForm.updateValueAndValidity();
  }
  add() {
    const formValue = this.typeOfChangesForm.value;
    const payload = {
      name: formValue.typeOfChanges,
      category_id: formValue.category.id,
    };
    this.auditService.addTypeOfChanges(payload).subscribe({
      next: (res) => {
        this.toast.showSuccess("success", res.message);
        this.closeDialog.emit();
        this.typeOfChangesForm.reset();
      },
      error: (error) => {
        // this.toast.showError("error", error);
      },
    });
  }
  update() {
    const formValue = this.typeOfChangesForm.value;
    const payload = {
      name: formValue.typeOfChanges,
      category_id: formValue.category.id,
    };
    this.auditService.updateTypeOfChanges(this.data.id, payload).subscribe({
      next: (res) => {
        this.toast.showSuccess("success", res.message);
        this.closeDialog.emit();
        this.typeOfChangesForm.reset();
      },
      error: (error) => {
        // this.toast.showError("error", error);
      },
    });
  }
  onSubmit() {
    this.permissionPop = true;
  }
  getChangeTypeCategories() {
    this.auditService.getChangeTypeCategories().subscribe({
      next: (response) => {
        this.category = response.change_type_categories;
      },
      error: (err) => {},
    });
  }
  onSubmitPermission(event: any) {
    if (this.editMode) {
      this.update();
    } else {
      this.add();
    }

    this.permissionPop = false;
  }
  onCancelPermission(event: any) {
    this.permissionPop = false;
  }
}
